import React from 'react'
import axios from 'axios'
import Router from 'next/router'
import css from '../../static/css/banner.css'
import { Link } from 'react-scroll'

export default class extends React.Component{
  constructor(props){
    super(props)
    this.state={
      featured:''
    }
  }
  componentDidMount(){
    axios.get('https://gallery.unified.ph/albums?isActive=true')
    .then(res=>{
      const GetFeatured = res.data.filter( media => media.isFeatured === true)
      axios.get('https://gallery.unified.ph/albums/'+GetFeatured[0].id)
      .then(res=>{
        this.setState({featured:res.data.contents[0].url})
      })
      .catch(err=>console.log(err))
    })
    .catch(err=>console.log(err))
  }
  render(){
    return(
      <div className="cover home-cover">
        <div className="container" style={{paddingTop:'120px'}}>
          <div className="row justify-content-md-center">
            <div className="col-md-5">
              <div className="slogan-container">
                <p className="slogan">
                  We empower you<br/>
                  to build the future<br/>
                  you deserve!
                </p>
                <p className="slogan-sub">
                  In Unified Products and Services,
                  we continuously innovate the needs
                  of every Filipino entrepreneur in
                  attaining financial freedom through
                  our one-stop-shop business.
                </p>
                <Link to="info" smooth={true} offset={-80}  duration={800}>
                  <button className="btn btn-transparent-circular">Learn More</button>
                </Link>
              </div>
            </div>
            <div className="col-md-5">
              {this.state.featured !== '' ?
              <video style={{width:'100%', marginTop:'15px', backgroundColor:'black', marginBottom:'15px'}} controls controlsList="nodownload">
                <source src={this.state.featured} type="video/mp4"/>
              </video> :
              <div style={{minHeight:'260px'}}>
                <h3 className="text-center" style={{marginTop:'120px', color:'white', fontWeight:200}}>Loading video...</h3>
              </div>}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// components/home/Banner.js